import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@patientlynk3/views/login/login.component';
import { NotFoundComponent } from '@patientlynk3/views/not-found/not-found.component';
import { InvalidSharedLabComponent } from './views/invalid-shared-lab/invalid-shared-lab.component';

import { AuthGuard } from '@patientlynk3/services/auth/auth.guard';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { ContactGuard } from '@patientlynk3/views/contact/contact.guard';
import { ComplianceComponent } from './components/compliance/compliance.component';
import { theme } from '@theme/.';

// realistically this is a temporaty solution, there could be a better way of implementing this
const labs_path = theme.name == 'MisResultados' ? {path: 'labs', loadChildren: () => import('./views/legacy_labs/labs.module').then(m => m.LabsModule),canActivate: [AuthGuard]} : {path: 'labs', loadChildren: () => import('./views/labs/labs.module').then(m => m.LabsModule),canActivate: [AuthGuard]}

const routes: Routes = [
  // public routes
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
    // canActivate: [LoginGuard]
  },
  {
    path: 'contactUs',
    loadChildren: () => import('./views/contact/contact.module')
      .then(m => m.ContactModule),
    canLoad: [ContactGuard]
  },
  { path: 'ContactUs', redirectTo: '/contactUs' },
  {
    path: 'registration',
    loadChildren: () => import('./views/registration/registration.module')
      .then(m => m.RegistrationModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./views/faq/faq.module')
      .then(m => m.FaqModule)
  },
  {
    path: 'recovery',
    loadChildren: () => import('./views/recovery/recovery.module')
      .then(m => m.RecoveryModule)
  },
  {
    path: 'activate-account',
    loadChildren: () => import('./components/confirm-new-user/confirm-new-user.module')
      .then(m => m.ConfirmNewUserModule)
  },
  // protected routes
  {
    path: 'home',
    loadChildren: () => import('./views/home/home.module')
      .then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  { path: 'Home', redirectTo: '/home' },
  {
    path: 'mailbox',
    loadChildren: () => import('./views/mailbox/mailbox.module')
      .then(m => m.MailboxModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'health_records',
    loadChildren: () => import('./views/health-records/health-records.module')
      .then(m => m.HealthRecordsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'provider_communication',
    loadChildren: () => import('./views/provider-comunication/provider-comunication.module')
      .then(m => m.ProviderComunicationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'maps',
    loadChildren: () => import('./views/maps/maps.module')
      .then(m => m.MapsModule),
    canActivate: [AuthGuard]
  },
  // refrence this const at top to return the desired path for the appropriate client
  labs_path,
  { path: 'labResults/:id', redirectTo: '/labs/:id' },
  { path: 'invalidSharedLab', component: InvalidSharedLabComponent},
  { path: 'privacyPolicy', component: ComplianceComponent}, 
  {
    path: 'profile',
    loadChildren: () => import('./views/profile/profile.module')
      .then(m => m.ProfileModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'hra',
    loadChildren: () => import('./views/hra/hra.module')
      .then(m => m.HraModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'hra/:survey_id/:response_id',
    loadChildren: () => import('./views/hra/hra.module')
      .then(m => m.HraModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'privacy_settings',
    loadChildren: () => import('./views/privacy-settings/privacy-settings.module')
      .then(m => m.PrivacySettingsModule),
    canActivate: [AuthGuard]
  },
  // generic routes
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    preloadingStrategy: QuicklinkStrategy,
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
